import React, { useRef } from 'react';
import { bool, func, string } from 'prop-types';
import {
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Center,
  Box,
  Heading,
  Image,
} from '@chakra-ui/react';
import { AiOutlineHeart } from 'react-icons/ai';
import { Timeline, TimelineEvent } from 'react-event-timeline';

import useLang from '@/hooks/useLang';
import useInvitation from '@/hooks/useInvitation';

import storyData from '@/constants/love-story';
import { BUTTON_PADDING_PROPS } from '@/constants/colors';
import { TEXT_PROPS } from '@/constants/default-props';

import txtWording from './locales';

function LoveStoryContent({ onClose, visible }) {
  const invitation = useInvitation();
  const lang = useLang();
  const boxRef = useRef();

  const renderIcon = (img) => {
    if (img) {
      return (
        <Image
          src={img}
          boxSize="50px"
          borderRadius="full"
          objectFit="cover"
          objectPosition="center"
        />
      );
    }

    return <AiOutlineHeart color="white" size="18px" />;
  };

  return (
    <Drawer size="full" onClose={onClose} isOpen={visible} initialFocusRef={boxRef}>
      <DrawerOverlay />
      <DrawerContent maxW="500px">
        <DrawerBody padding={'2rem 2rem'} bg="bgPrimary">
          <Box
            margin="24px auto 16px auto"
            textAlign="center"
            position="relative"
            ref={boxRef}
            tabIndex={0}
          >
            <Heading {...TEXT_PROPS.heading} mb="24px">
              Our Love Story
            </Heading>
          </Box>
          <Timeline
            lineColor="var(--chakra-colors-bgAlternative)"
            lineStyle={{ top: '20px', height: 'calc(100% - 60px)', left: '25px' }}
          >
            {storyData.map((item, index) => {
              return (
                <TimelineEvent
                  key={`index-${index}`}
                  title={item.title}
                  titleStyle={{
                    color: 'var(--chakra-colors-secondaryColorText)',
                    fontSize: 'var(--chakra-fontSizes-2xl)',
                    fontWeight: 'bold',
                    paddingLeft: '20px',
                  }}
                  subtitleStyle={{ color: 'white' }}
                  cardHeaderStyle={{ color: 'white' }}
                  icon={renderIcon(item.img)}
                  iconStyle={{ width: '50px', height: '50px' }}
                  bubbleStyle={{
                    width: '50px',
                    height: '50px',
                    border: 'none',
                    backgroundColor: 'var(--chakra-colors-bgSecondary)',
                  }}
                  contentStyle={{
                    color: 'var(--chakra-colors-mainColorText)',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    paddingLeft: '20px',
                    marginTop: '8px',
                    fontSize: '1rem',
                  }}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.content }} />
                </TimelineEvent>
              );
            })}
          </Timeline>
          <Center mb="15svh">
            <Button {...BUTTON_PADDING_PROPS} onClick={onClose} mt="12px">
              {invitation ? txtWording.invitationBack[lang] : txtWording.back[lang]}
            </Button>
          </Center>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

LoveStoryContent.propTypes = {
  lang: string,
  visible: bool.isRequired,
  onClose: func.isRequired,
};

LoveStoryContent.defaultProps = {
  lang: 'id',
};

export default LoveStoryContent;
